import React, { useContext, useRef } from "react";
import styles from "./Question.module.scss";
const Question = (props) => {
  const refBtns = useRef([]);
  const clickHandler = (id) => {
    const btns = refBtns.current;
    btns[id].classList.add(styles.active);
    btns[1-id].classList.remove(styles.active);
    btns[id].classList.remove(styles.disable);
    btns[1-id].classList.add(styles.disable);
  }
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.text}>{props.children}</div>
        <div className={styles.btns}>
          <div className={`${styles.btn} ${styles.btn_black}`} ref={element=>refBtns.current[0] = element} onClick={()=>clickHandler(0)}>Да</div>
          <div className={`${styles.btn}`} ref={element=>refBtns.current[1] = element} onClick={()=>clickHandler(1)}>Нет</div>
        </div>
      </div>
    </>
  );

}

export default Question;
